module.exports = __webpack_public_path__ + "static/fetch-can-trick-6cff90bee3c00a779512e6a562d0fa12.jpg";